
function TrendingProductPage() {

    return (
        <div className="flex flex-col items-center bg-backgroundGrayColor w-full pt-8">
            Đây là trang sản phẩm đang thịnh hành
        </div>
    );
};
export default TrendingProductPage;